import { Component, Inject, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/modules/shared/services';
import { AuthService } from 'src/app/services';
import { DataService } from 'src/app/services/data/data.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DealPreviewService } from 'src/app/modules/deals/services/deal-preview.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IDealCard } from '../../models';
import { ModalSize } from '../../services/util/util.service';

// enum DealInterestStage { GUEST,  }



@Component({
  selector: 'app-interested-in-deal-modal',
  templateUrl: './interested-in-deal-modal.component.html',
  styleUrls: ['./interested-in-deal-modal.component.scss']
})
export class InterestedInDealModalComponent implements OnInit {

  displayGuestForm: boolean = false;
  userLoggedIn: boolean = false;
  fgGuest : FormGroup = new FormGroup({
    name: new FormControl("", Validators.required),
    email: new FormControl("", [Validators.required, Validators.email]),
    phone:  new FormControl(""),
    company:  new FormControl("", Validators.required),
    title:  new FormControl("", Validators.required),
    notes:  new FormControl(""),
  });

  fgUser: FormGroup = new FormGroup({
    notes:  new FormControl(""),
  });

  constructor(
    private dealPreviewService: DealPreviewService,
    // private activedRoute: ActivatedRoute,
    private router: Router,
    // private dataService: DataService,
    private toastr: ToastrService,
    private authService: AuthService,
    private util: UtilService,
    public dialogRef: MatDialogRef<InterestedInDealModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { deal: IDealCard }

  ) { 
    // console.log("Data", data);
  }

  ngOnInit(): void {
    // is the user loggedIn?
    this.authService.IsLoggedIn().subscribe({
      next: (res: boolean) => {
        this.userLoggedIn = res;
      }
    });

  }

  sendGuestInterest() {
    if (this.fgGuest.invalid) {
      this.fgGuest.markAllAsTouched();
      return;
    }

    var payload = {
      ...this.fgGuest.value,
      dealId: this.data.deal.id,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    
    console.log("Guest interest clicked", payload);
    this.dealPreviewService.sendDealInterestAsGuest(payload).subscribe({
      next: (res) => {
        console.log("Guest interest sent", res);
        this.toastr.success("Your interest has been received. We will get back to you shortly.");
        this.dialogRef.close();
      }
    });
  }


  // /// User logged in interest
  // expressInterest() {
  //   console.log("Express interest clicked", this.fgUser.value);

  //   var payload = {
  //     ...this.fgUser.value,
  //     dealId: this.data.deal.id,
  //     // dealName: this.data.deal.projectName
  //   };

  //   this.dealPreviewService.sendDealInterestAsUser(payload).subscribe({
  //     next: (res) => {
  //       console.log("User interest sent", res);
  //       this.toastr.success("Rondeivu is reviewing your request to be matched to this deal. We will get back to you shortly.");
  //       this.dialogRef.close();
  //     }
  //   });
  // }

  routeToLogin() {
    this.dialogRef.close();
    var queryParams = { action: 'deal-interest', dealId: this.data.deal.id };
    this.router.navigate(['/auth/login'], { queryParams });
  }

  routeToRegister() {
    this.dialogRef.close();
    var queryParams = { profile: 'investor', action: 'deal-interest', dealId: this.data.deal.id };
    this.router.navigate(['/auth/register'], { queryParams });
  }

  changeToGuestForm() {
    this.displayGuestForm = true;
    this.dialogRef.updateSize(this.util.getModalWidth(ModalSize.LARGE));
  }
}
